import { z } from 'zod';

export const NotificationIdSchema = z.string().regex(/^(project|account):[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);
export const NotificationQuerySchema = z.object({
  unread: z.enum(['true', 'false']).default('true'),
  cursor: z.string().max(500).optional(),
});
export const ReadNotificationsSchema = z.object({
  ids: z.array(NotificationIdSchema).min(1).max(100),
  readAt: z.string().datetime().optional(),
}).strict();
export const READ_NOTIFICATION_RETENTION_MS = 30 * 24 * 60 * 60 * 1000;
/** Keep receipts and the original audit history; only hide old read inbox items. */
export function notificationStillVisible(readAt: string | Date | null, now = Date.now()) {
  return !readAt || new Date(readAt).getTime() > now - READ_NOTIFICATION_RETENTION_MS;
}

export type SiteNotification = {
  id: string;
  kind: string;
  title: string;
  detail: string;
  actorName: string;
  projectId: string | null;
  projectName: string | null;
  snagId: string | null;
  snagReference: string | null;
  snagTitle: string | null;
  occurredAt: string;
  readAt: string | null;
  canOpen: boolean;
};
export type NotificationFeed = { items: SiteNotification[]; unreadCount: number; nextCursor: string | null };
export type NotificationQuery = { unread: boolean; cursor?: string };
